const drawer = document.getElementById("drawer");
const drawerBody = document.querySelector(".drawer-body");

async function initializeDrawer(currency, item_count, items, total_price) {
  const itemCounter = document.getElementById("item-counter");
  itemCounter.innerText = item_count;

  const itemTemplate = `
        <div class='item'>
            <a href="/products/{{url}}">
            <img src="{{img}}">
            </a>
            <div>
                <div class="details">
                    <div class="flex-row">
                        <a href="/products/{{url}}" class="product-title">{{title}}</a>
                        <button class="remove-item" onClick="removeItem('{{productId}}')">Rimuovi</button>
                    </div>
                    <p class="product-price">{{price}}</p>
                    <p class="product-sku">{{sku}}</p>
                </div>
            </div>
        </a>
    `;

  drawerBody.innerHTML = "";
  items.forEach((item) => {
    drawerBody.innerHTML += itemTemplate
      .replace("{{url}}", item.handle)
      .replace("{{url}}", item.handle)
      .replace("{{img}}", item.featured_image.url)
      .replace("{{title}}", item.title)
      .replace("{{productId}}", item.id)
      .replace(
        "{{price}}",
        ("€" + (item.price / 100).toFixed(2)).replace(".", ",")
      )
      .replace("{{sku}}", item.sku);
  });
}

function updateDrawer() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((result) => {
      const currency = result.currency;
      const item_count = result.item_count;
      const items = result.items;
      const total_price = result.total_price;

      initializeDrawer(currency, item_count, items, total_price);

      const checkoutButton = document.getElementById("drawer-checkout");
      const emptyCartMessage = document.getElementById("empty-cart");

      if (items.length > 0) {
        checkoutButton.style.display = "block";
        emptyCartMessage.style.display = "none";
        drawerBody.style.display = "block";
      } else {
        checkoutButton.style.display = "none";
        emptyCartMessage.style.display = "block";
        drawerBody.style.display = "none";
      }

      console.log(result);
    });
}

// Refresh/Initialize drawer on window load
updateDrawer();

//*********** Must be triggered also on add to cart 200.

// Drawer status handler
const drawerButtons = document.querySelectorAll("#drawer_button");

drawerButtons.forEach((drawerButton) => {
  drawerButton.addEventListener("click", () => {
    drawer.classList.toggle("active");
  });
});
